export const muvi = {
  hero: {
    title1: 'MuVi Space｜目靡空間',
    title2: 'Create.',
    title3: 'Record.',
    title4: 'Broadcast.',
    subtitle: 'Podcast、直播、Casting、品牌訪談與短影音拍攝空間',
    cta: '立即預約',
  },
  features: {
    title: '場地特色',
    subtitle: '一個人帶著手機或相機即可開始創作',
    podcast: { title: 'Podcast 錄製', desc: '專業隔音空間，支援多軌錄音，適合雙人對談或多人圓桌形式。' },
    livestream: { title: '現場直播', desc: '穩定高速網路與多機位切換設備，支援各大直播平台串流。' },
    casting: { title: 'Casting 空間', desc: '獨立試鏡區域，配備專業燈光與監看系統，適合演員選角與試鏡。' },
    productShooting: { title: '商品拍攝', desc: '寬敞無影牆與環物攝影台，適合各類商品情境拍攝與電商素材製作。' },
    interview: { title: '品牌訪談', desc: '舒適訪談佈景，自然光與專業燈光並用，打造品牌形象影片。' },
    workshop: { title: '工作坊 / 講座', desc: '可容納 15-20 人的彈性空間，適合小型講座、工作坊與教育訓練。' },
  },
  gallery: {
    title: '場地實景',
    subtitle: '多元場景，隨時替換',
    podcast: 'Podcast 錄音室',
    livestream: '直播間',
    productShooting: '商品攝影區',
    interview: '訪談空間',
    workshop: '工作坊空間',
    casting: 'Casting 區',
  },
  equipment: {
    title: '設備與服務',
    subtitle: '設備依專案需求確認，可搭配現場與租賃資源彈性配置',
    microphone: { title: '專業麥克風', desc: '以 RØDE、Shure 等專業麥克風為主，實際型號與數量依預約需求另行確認。' },
    lighting: { title: '燈光系統', desc: '以 Aputure、Godox、SIRUI 等影視燈具為主，可依場景需求搭配柔光、補光與控光配件。' },
    liveStreaming: { title: '直播設備', desc: '直播導播設備以 CINETREAK CineTreak C2 或 ATEM 為主，支援方案與現場配置需依專案需求另行確認。' },
    tripod: { title: '腳架與穩定器', desc: 'Manfrotto 專業腳架、DJI 穩定器，確保畫面穩定流暢。' },
    monitor: { title: '監看螢幕', desc: '多台監看螢幕，導演與客戶可即時確認畫面構圖與燈光。' },
    switcher: { title: '導播 / 控台設備', desc: '導播與控台設備以 CINETREAK CineTreak C2 或 ATEM 為主，實際可用型號、數量與操作需求依預約內容確認。' },
  },
  pricing: {
    title: '價格方案',
    subtitle: '透明定價，無隱藏費用',
    venue: '場地費用',
    venuePrice: 'NT$500 / 小時',
    venueDesc: '包含基礎燈光、空調、Wi-Fi',
    techSupport: '技術支援',
    techPrice: 'NT$200 / 小時',
    techDesc: '專業技術人員現場協助',
    note: '最低預約 2 小時起',
  },
  faq: {
    title: '常見問題',
    subtitle: '關於 MuVi Space 的常見疑問',
    q1: '是否提供停車位？',
    a1: 'MuVi Space 位於 LensBank 門市內，周邊有付費停車場及路邊停車格。如需裝卸器材，門口可臨時停車。',
    q2: '是否提供 Wi-Fi？',
    a2: '場地提供高速光纖網路 Wi-Fi，上傳/下載速度皆達 300Mbps 以上，確保直播與檔案傳輸穩定。',
    q3: '可以使用到深夜嗎？',
    a3: 'MuVi Space 標準營業時間為 09:00 - 22:00。若有深夜使用需求，請於預約時特別註明，我們將視情況安排，可能產生額外費用。',
    q4: '可以自行攜帶設備嗎？',
    a4: '當然可以！您可以自由攜帶自己的攝影器材、燈光或錄音設備。我們也提供完整的設備租用服務，歡迎搭配使用。',
    q5: '預約需要提前多久？',
    a5: '建議至少提前 3 個工作天預約，以確保場地與人力安排。急件需求歡迎直接來電洽詢。',
    q6: '可以取消或更改預約嗎？',
    a6: '預約成立後如需更改或取消，請於使用日前 48 小時通知。當日取消將收取 50% 費用。',
    q7: '場地可以容納多少人？',
    a7: 'MuVi Space 總面積約 20 坪，適合 2-15 人的拍攝團隊。若需更大空間或特殊佈景需求，請提前與我們討論。',
    q8: '是否有提供餐飲服務？',
    a8: '場地備有茶水間，提供咖啡、茶飲及礦泉水。如需餐飲外送或 catering 服務，我們可協助代訂。',
  },
  booking: {
    title: '預約 MuVi Space',
    subtitle: '填寫以下表單，我們將盡快與您確認',
    formTitle: '預約申請表',
    companyName: '公司名稱',
    companyNamePlaceholder: '請輸入公司或單位名稱',
    contactName: '聯絡人',
    contactNamePlaceholder: '請輸入聯絡人姓名',
    phone: '聯絡電話',
    phonePlaceholder: '例：0912-345-678',
    email: 'Email',
    emailPlaceholder: 'example@company.com',
    activityType: '活動類型',
    activityTypePlaceholder: '請選擇活動類型',
    date: '預計日期',
    startTime: '開始時間',
    endTime: '結束時間',
    needTechSupport: '是否需要技術支援',
    needTechSupportYes: '需要（+NT$200/小時）',
    needTechSupportNo: '不需要',
    notes: '備註',
    notesPlaceholder: '如有特殊需求請在此說明，例如：需要的設備、場地佈置需求等...',
    notesMaxChars: '最多 500 字',
    pricingSummary: '預估費用',
    venueFee: '場地費用',
    techFee: '技術支援費用',
    hours: '小時',
    total: '合計',
    submitButton: '送出預約申請',
    submitting: '送出中...',
    noticeTitle: '重要提醒',
    noticeText: '送出後僅為預約申請。預約成立需待 MuVi Space 確認場地與人力安排。我們將於 1-2 個工作天內與您聯繫。',
    required: '*',
    successTitle: '預約申請已送出',
    successMessage: '感謝您的預約！預約送出不代表預約已成立，需待 Muvi Space 確認場地與時段後才算完成。我們將盡快與您聯繫。',
    backToHome: '返回 MuVi Space',
  },
  activityTypes: {
    podcast: 'Podcast 錄製',
    livestream: '現場直播',
    casting: 'Casting',
    brandInterview: '品牌訪談',
    productShooting: '商品拍攝',
    courseRecording: '課程錄製',
    other: '其他',
  },
  admin: {
    bookings: {
      title: 'MuVi Space｜目靡空間 預約管理',
      subtitle: '檢視與管理所有 MuVi Space 預約申請',
      bookingId: '預約編號',
      customer: '客戶',
      date: '日期',
      time: '時間',
      activityType: '活動類型',
      estimatedAmount: '預估金額',
      status: '狀態',
      detail: '查看詳情',
      history: '歷程記錄',
      notes: '備註',
      statusPending: '待確認',
      statusStaffingReview: '人力審核中',
      statusConfirmed: '已確認',
      statusRejected: '已婉拒',
      statusCancelled: '已取消',
      mockBanner: '模擬資料 — 尚未連接資料庫',
    },
    content: {
      title: 'MuVi Space｜目靡空間 內容管理',
      subtitle: '管理前台顯示內容、圖片與區塊設定',
      hero: '主視覺區塊',
      heroDesc: '管理 Hero 區的背景圖片',
      gallery: '場地照片管理',
      galleryDesc: '管理場地實景照片輪播',
      equipmentImages: '設備圖片管理',
      equipmentImagesDesc: '管理設備與服務區塊圖片',
      features: '特色區塊管理',
      featuresDesc: '管理場地特色卡片內容與排序',
      faq: 'FAQ 管理',
      faqDesc: '管理常見問題內容',
      mockBanner: '模擬資料 — 尚未連接資料庫',
      save: '儲存變更',
      saved: '已儲存',
      addImage: '新增圖片',
      uploadImage: '上傳圖片',
      imageUrl: '圖片網址',
      altText: '替代文字',
      sortOrder: '排序',
      active: '啟用',
      inactive: '停用',
      delete: '刪除',
      maxImages: '每個區塊最多 6 張圖片',
    },
    settings: {
      title: 'MuVi Space｜目靡空間 設定',
      subtitle: '管理預約相關設定與聯絡資訊',
      venueHourlyRate: '場地時薪 (NT$)',
      techHourlyRate: '技術人員時薪 (NT$)',
      bookingNotice: '預約說明文字',
      bookingNoticePlaceholder: '輸入預約頁面顯示的說明文字...',
      contactPhone: '聯絡電話',
      contactEmail: '聯絡 Email',
      googleMapEmbed: 'Google Map 嵌入網址',
      googleMapPlaceholder: '貼上 Google Maps 嵌入 iframe 網址...',
      saveSettings: '儲存設定',
      saved: '設定已儲存',
      mockBanner: '模擬資料 — 尚未連接資料庫',
    },
  },
};
